import { render, staticRenderFns } from "./DeviceDeletion.vue?vue&type=template&id=21835706&scoped=true&"
import script from "./DeviceDeletion.vue?vue&type=script&lang=ts&"
export * from "./DeviceDeletion.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDeletion.vue?vue&type=style&index=0&id=21835706&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21835706",
  null
  
)

export default component.exports